import { AvailabilityType } from 'api/services/availability/availability-service.schema';

export const getColorForAvailabilityType = (type: AvailabilityType, opacity = 1): string => {
  switch (type) {
    case 'available':
      return `rgba(0, 43, 255, ${opacity})`;
    case 'tentative':
      return `rgba(255, 153, 102, ${opacity})`;
    case 'pending':
      return `rgba(0, 204, 136, ${opacity})`;
    case 'blocked':
    default:
      return `rgba(0, 0, 0, ${opacity})`;
  }
};
